import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AdultFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M15.329 8.73784C14.6581 8 13.7118 8 12 8C10.2882 8 9.33333 8 8.67097 8.73784C8 9.47567 8 10.5162 8 12.3986V13.8176C8 14.8108 8 15.4067 8.4129 15.8703C8.72258 16.2108 9.10108 16.2959 9.63441 16.3149H9.72043V19.4932C9.72043 20.4865 9.72043 21.0824 10.1333 21.5459C10.5381 22.0003 11.0751 22.0002 11.9469 22L12 22C12.9032 22 13.4452 22 13.8667 21.5459C14.2798 21.1009 14.2797 20.5103 14.2796 19.5517L14.2796 19.4932V16.3243H14.3656C14.8989 16.2959 15.2774 16.2203 15.5871 15.8703C16 15.4162 16 14.8108 16 13.8176V12.3986C16 10.5068 16 9.46621 15.329 8.73784Z"
				fill="currentColor"
			/>
			<path
				d="M12.0645 7.0237C13.4774 7.0237 14.629 5.89573 14.629 4.51185C14.629 3.12796 13.4774 2 12.0645 2C10.6516 2 9.5 3.12796 9.5 4.51185C9.5 5.89573 10.6516 7.0237 12.0645 7.0237Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AdultFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AdultFilledIcon;
